import View from './View.js';


class PreviewView extends View {
  _parentElemnt = '';

  _generateMarkup() {
    return `
    <div class="d-flex justify-content-between border p-3 mt-5 rounded">
        <div class="text"> כמות דגם ox </div>
         <div class="ox">${new Intl.NumberFormat('en-IN').format(this._data.ox)} יח </div>
    </div>

    <div class="d-flex justify-content-between border p-3 mt-3 rounded">
        <div class="text"> כמות דגם quick4 </div>
        <div class="ox">${new Intl.NumberFormat('en-IN').format(this._data.quick4)} יח </div>
    </div>

    <div class="d-flex justify-content-between border p-3 mt-3 rounded">
        <div class="text"> כמות דגם light2 </div>
        <div class="ox">${new Intl.NumberFormat('en-IN').format(this._data.ligh2)} יח </div>
    </div>

    <div class="d-flex justify-content-between border p-3 mt-3 rounded">
        <div class="text"> כמות דגם quick3 </div>
        <div class="ox">${new Intl.NumberFormat('en-IN').format(this._data.quick3)} יח </div>
    </div>

    <div class="d-flex justify-content-between border p-3 mt-3 rounded">
        <div class="text"> סהכ: </div>
        <div class="ox">${new Intl.NumberFormat('en-IN').format(this._data.ligh2 + this._data.quick4 + this._data.ox + this._data.quick3)} יח </div>
    </div>

`;
  }
}

export default new PreviewView();
